import request from '@/api/request';
// const bitrixRequest = process.env.NODE_ENV === 'production' ? request() : request(process.env.BITRIX_API);
const defaultRequest = request();

export function BitrixContactsRequest (params) {
  return defaultRequest({
    url: 'crmbitrix/account/contacts',
    params
  });
}

export function BitrixTicketsRequest (params) {
  return defaultRequest({
    url: 'crmbitrix/account/ticket',
    params
  });
}

export function ExportTicketsBySupporter (params) {
  return defaultRequest({
    url: 'crmbitrix/account/Exportticket',
    method: 'get',
    params
  });
}

export function GetUserGroup () {
  return defaultRequest({
    url: 'crmbitrix/user/groups'
  });
}

export function GetTicketByDate (params) {
  return defaultRequest({
    url: 'crmbitrix/ticket/ticketbydate',
    params
  });
}

export function GetAllTicket () {
  return defaultRequest({
    url: 'crmbitrix/ticket/all'
  });
}

export function GetAllTechnicalUser () {
  return defaultRequest({
    url: 'crmbitrix/user/getalltechnicaluser'
  });
}

export function GetTicketNotAssign () {
  return defaultRequest({
    url: 'crmbitrix/ticketNotAssign'
  });
}

export function ReturnTicket (data) {
  return defaultRequest({
    url: 'crmbitrix/case/ReturnCase',
    method: 'post',
    data
  });
}

export function TicketDispatchCrmBitrix (data) {
  return defaultRequest({
    url: 'crmbtrix/case/dispatch',
    method: 'post',
    data
  });
}

export function PushTicketNotAssign (data) {
  return defaultRequest({
    url: 'crmbitrix/pushTicketNotAssign',
    method: 'post',
    data
  });
}


// WEBPACK FOOTER //
// ./src/api/crm-bitrix.js